const devConfigs = {
    apiUrl : 'https://dev.api.smart-charter.io',
    adminLink : 'https://dev.api.smart-charter.io/sm-charter-admin'
}

export default devConfigs;